/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageRandomJoke,
  HomePageRecentlyVisited,
  HomePageTopVisited,
  WelcomeTitle,
} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles } from '@material-ui/core';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import MessageIcon from '@material-ui/icons/Message';
import ArchitectureLogo from '../architecture/images/ArchitectureLogo';
import DevSecOpsLogo from '../devsecops/images/DevSecOpsLogo';

const useStyles = makeStyles(theme => ({
  searchBar: {
    display: 'flex',
    maxWidth: '60vw',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    padding: '8px 0',
    borderRadius: '50px',
    margin: 'auto',
  },
}));

export const HomePage = () => {
  const classes = useStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Header
          title={<WelcomeTitle language={['English', 'Spanish']} />}
          pageTitleOverride="Home"
        />
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                classes={{ root: classes.searchBar }}
                placeholder="Search"
              />
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageRecentlyVisited />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageTopVisited />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageToolkit
                  tools={[
                    {
                      url: '/architecture-center',
                      label: 'Arch Center',
                      icon: <ArchitectureLogo />,
                    },
                    {
                      url: '/docs/default/resource/wiki/devsecops/introduction/',
                      label: 'DevSecOps',
                      icon: <DevSecOpsLogo />,
                    },
                    {
                      url: '/events',
                      label: 'Events',
                      icon: <MessageIcon />,
                    },
                    {
                      url: '/docs/default/resource/wiki',
                      label: 'Wiki',
                      icon: <LocalLibraryIcon />,
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageStarredEntities />
              </Grid>
              <Grid item xs={12}>
                <HomePageRandomJoke />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
